import { render, staticRenderFns } from "./NgGreenData.vue?vue&type=template&id=35668352&scoped=true"
import script from "./NgGreenData.vue?vue&type=script&setup=true&lang=js"
export * from "./NgGreenData.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NgGreenData.vue?vue&type=style&index=0&id=35668352&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35668352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35668352')) {
      api.createRecord('35668352', component.options)
    } else {
      api.reload('35668352', component.options)
    }
    module.hot.accept("./NgGreenData.vue?vue&type=template&id=35668352&scoped=true", function () {
      api.rerender('35668352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/public/NgGreenData.vue"
export default component.exports